var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6988 33.2811C27.5114 33.4684 27.2573 33.5737 26.9923 33.5737C26.7273 33.5737 26.4732 33.4684 26.2858 33.2811L24.7008 31.6961C24.5135 31.5087 24.4082 31.2546 24.4082 30.9896C24.4082 30.7246 24.5135 30.4705 24.7008 30.283L30.2832 24.7007C30.4706 24.5133 30.7247 24.4081 30.9897 24.4081C31.2547 24.4081 31.5088 24.5133 31.6963 24.7007L33.2812 26.2856C33.4686 26.4731 33.5738 26.7272 33.5738 26.9922C33.5738 27.2572 33.4686 27.5113 33.2812 27.6987L27.6988 33.2811Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9901 24.9935L28.616 18.124C28.5786 17.9371 28.4886 17.7648 28.3565 17.6274C28.2244 17.49 28.0558 17.3932 27.8705 17.3485L15.2347 14.0287C15.0682 13.9884 14.8942 13.9916 14.7293 14.038C14.5645 14.0843 14.4143 14.1723 14.2932 14.2934C14.1721 14.4145 14.0841 14.5647 14.0378 14.7295C13.9914 14.8944 13.9882 15.0684 14.0285 15.2349L17.3483 27.8707C17.393 28.0559 17.4898 28.2246 17.6272 28.3567C17.7646 28.4888 17.9369 28.5788 18.1238 28.6162L24.9933 29.9903",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3003 14.3005L21.5816 21.5817",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9948 24.9935C24.0986 24.9935 24.9935 24.0986 24.9935 22.9948C24.9935 21.8909 24.0986 20.9961 22.9948 20.9961C21.8909 20.9961 20.9961 21.8909 20.9961 22.9948C20.9961 24.0986 21.8909 24.9935 22.9948 24.9935Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiDesign);
export default __webpack_public_path__ + "static/media/UI Design.52f5e729eb1923003996205067597658.svg";
export { ForwardRef as ReactComponent };